"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTerminalControlTerminalStatusValidation = void 0;
class PaymentTerminalControlTerminalStatusValidation {
    static isValid(entity) {
        // Validate entity.connected for existence and correct type.
        if (entity.connected == undefined)
            return false;
        if (typeof entity.connected !== "boolean")
            return false;
        // Validate entity.attached for existence and correct type.
        if (entity.attached == undefined)
            return false;
        if (typeof entity.attached !== "boolean")
            return false;
        // Validate entity.faulted for existence and correct type.
        if (entity.faulted == undefined)
            return false;
        if (typeof entity.faulted !== "boolean")
            return false;
        // Validate entity.tampered for existence and correct type.
        if (entity.tampered == undefined)
            return false;
        if (typeof entity.tampered !== "boolean")
            return false;
        // Validate entity.accepting_payments for existence and correct type.
        if (entity.accepting_payments == undefined)
            return false;
        if (typeof entity.accepting_payments !== "boolean")
            return false;
        // Validate entity.software_ready for existence and correct type.
        if (entity.software_ready == undefined)
            return false;
        if (typeof entity.software_ready !== "boolean")
            return false;
        // Validate entity.ready for existence and correct type.
        if (entity.ready == undefined)
            return false;
        if (typeof entity.ready !== "boolean")
            return false;
        // Validate entity.serial_number for existence and correct type.
        if (entity.serial_number == undefined)
            return false;
        if (typeof entity.serial_number !== "string")
            return false;
        // Validate entity.firmware_version for existence and correct type.
        if (entity.firmware_version == undefined)
            return false;
        if (typeof entity.firmware_version !== "string")
            return false;
        // Validate entity.sdk_version for existence and correct type.
        if (entity.sdk_version == undefined)
            return false;
        if (typeof entity.sdk_version !== "string")
            return false;
        return true;
    }
}
exports.PaymentTerminalControlTerminalStatusValidation = PaymentTerminalControlTerminalStatusValidation;
